<template>
  <div
    v-on:mouseenter="hoverHandler"
    v-on:mouseleave="hoverHandler"
    class="sonar-skill-progress"
  >
    <div class="sonar-skill-progress__header">
      <div class="sonar-skill-progress__title">{{ skill.name }}</div>
      <div v-if="isJustTested" class="sonar-skill-progress__last-tested">
        Just Tested
      </div>
      <transition name="fade">
        <div v-show="isHovered" class="sonar-skill-progress__proficiency">
          {{ difficultyLabel }}
        </div>
      </transition>
    </div>
    <div class="sonar-skill-progress__content">
      <SonarProgressBar
        v-for="(progressBar, index) in progressBars"
        :key="index"
        :barProgress="scoreBar(progressBar.score)"
        :index="index"
      />
    </div>
  </div>
</template>

<script>
import SonarProgressBar from '@/sonar/components/SonarProgressBar.vue'
import { capitalize } from '@/helpers/textTransform'

export default {
  name: 'SonarSkillProgress',
  components: {
    SonarProgressBar,
  },
  props: {
    skill: {
      type: Object,
      required: true,
    },
    isJustTested: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      isHovered: false,
    }
  },
  computed: {
    currentScore() {
      return `${this.roundTo2(this.skill.score)}%`
    },
    progressBars() {
      return this.skill.difficulty_scores
    },
    difficultyLabel() {
      const difficulty = this.skill.level
      return capitalize(difficulty)
    },
  },
  methods: {
    roundTo2(n) {
      return Math.floor(n * 100)
    },
    hoverHandler() {
      this.isHovered = !this.isHovered
    },
    scoreBar(score) {
      return this.roundTo2(score)
    },
  },
}
</script>

<style lang="scss" scoped>
.sonar-skill-progress {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 7px;
  height: 24px;
  &__header {
    position: absolute;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 24px;
  }
  &__title {
    color: var(--white);
    font-size: rem(12);
    z-index: 10;
    margin-left: 5px;
  }
  &__content {
    display: flex;
    width: 100%;
    gap: 4px;
  }
  &__last-tested {
    display: none;
    position: absolute;
    height: 16px;
    color: var(--white);
    font-size: rem(10);
    line-height: rem(10);
    padding: 3px;
    border-radius: 5px;
    background: var(--purple-gradient);
    left: -65px;
    top: 4.5px;
    @include tablet {
      display: block;
    }
  }
  &__proficiency {
    position: absolute;
    font-size: rem(10);
    line-height: rem(12);
    right: 10px;
    color: var(--white);
    transition: 0.3;
    z-index: 100;
  }
}
</style>
